import React, { useEffect, useState } from "react";
import trans from "../../../../utils";
import { Switch, TimePicker } from "antd";
import dayjs from "dayjs";
const { RangePicker } = TimePicker;

export default function POIsWorkingShift({ day, workingHours, setFieldValue }) {
	const [active, setActive] = useState(false);
	const [startTime, setStartTime] = useState(dayjs("14:00", "HH:mm"));
	const [endTime, setEndTime] = useState(dayjs("17:00", "HH:mm"));
	const [time, setTime] = useState();
	const format = "HH:mm";

	// Toggle Switch
	const onChange = (checked) => {
		setActive(checked);
		if (!checked) {
			const updated = workingHours?.filter((item) => item.day !== day);
			setFieldValue("workingHours", updated);
		} else {
			pushTime(startTime, endTime);
		}
	};

	const pushTime = (start, end) => {
		const updated = workingHours?.filter((item) => item.day !== day) || [];
		updated.push({
			day,
			startTime: start.format(format),
			endTime: end.format(format),
		});
		setFieldValue("workingHours", updated);
	};

	// When time changes and switch is ON
	useEffect(() => {
		if (active) {
			pushTime(startTime, endTime);
		}
	}, [startTime, endTime]);

	// Optional: prefill `active` if day is already in workingHours
	useEffect(() => {
		const existing = workingHours?.find((item) => item.day === day);
		if (existing) {
			setActive(true);
			setStartTime(dayjs(existing.startTime, format));
			setEndTime(dayjs(existing.endTime, format));
		}
	}, []);

	return (
		<div className="poi-working-days">
			<div className="poi-working-day">{trans(day)}</div>
			{active && (
				<>
					<RangePicker
						placeholder={[trans("Start"), trans("End")]}
						onChange={(e) => {
							if (e && e[0] && e[1]) {
								const startTime = e[0];
								const endTime = e[1];
								setStartTime(startTime);
								setEndTime(endTime);
								setTime(e);
							} else {
								console.log("No time selected");
							}
						}}
						value={[startTime, endTime]}
						format={format}
					/>
				</>
			)}
			<Switch onChange={onChange} checked={active} />
		</div>
	);
}
